import React from "react";


import MaterialTable, { Action, Column, MaterialTableProps } from "material-table";

type LegacyTableActionClick<T extends object> = {
    bivarianceHack(event: unknown, data: T | T[]): void;
}['bivarianceHack'];

type LegacyTableAction<T extends object> = Omit<Action<T>, 'onClick'> & {
    onClick?: LegacyTableActionClick<T> | ((event?: unknown, data?: unknown) => void);
};

type LegacyDetailPanelClick<T extends object> = {
    bivarianceHack(
        event?: { preventDefault: () => void },
        rowData?: T,
        toggleDetailPanel?: (panelIndex?: number) => void
    ): void;
}['bivarianceHack'];

type LegacyDetailPanel<T extends object> = {
    disabled?: boolean;
    icon?: MaterialTableProps<T>['icons'];
    openIcon?: MaterialTableProps<T>['icons'];
    tooltip?: string;
    render: (rowData: T) => React.ReactNode;
    onClick?: LegacyDetailPanelClick<T>;
};

type LegacyRowClick<T extends object> = {
    bivarianceHack(
        event?: { preventDefault?: () => void } | React.MouseEvent,
        rowData?: T,
        toggleDetailPanel?: (panelIndex?: number) => void
    ): void;
}['bivarianceHack'];

export interface CustomDataTableProps<T extends object = object> extends Omit<MaterialTableProps<T>, 'actions' | 'columns' | 'data' | 'detailPanel' | 'onRowClick'> {
    actions?: Array<LegacyTableAction<T> | Action<T> | ((rowData: T) => LegacyTableAction<T>) | Record<string, unknown>>;
    columns?: Column<T>[] | unknown[];
    data?: T[] | unknown;
    detailPanel?: MaterialTableProps<T>['detailPanel'] | LegacyDetailPanel<T>[];
    onRowClick?: LegacyRowClick<T>;
    simple?: boolean
}

const CustomDataTable: <T extends object = object>(props: CustomDataTableProps<T>) => JSX.Element = <T extends object = object>({
    simple = false,
    ...props
}: CustomDataTableProps<T>) => {

    var {
        title,
        options,
        ...rest
    } = props;

    var tempOptions = {
        exportAllData: true,
        exportButton: true,
        grouping: !simple,
        paging: !simple,
        toolbar: !simple,
        actionsColumnIndex: -1,
        columnsButton: true,
        headerStyle: {
            zIndex: 0
        },
        pageSizeOptions: [50, 100, 500],
        emptyRowsWhenPaging: false,
    }


    if (options) {
        Object.assign(tempOptions, options);
    }
    //Object.assign(dataTableProps, rest);

    return (
        <MaterialTable
            title={title || ' '}
            options={tempOptions}
            {...rest as MaterialTableProps<T>}
        />
    )
};

export default CustomDataTable;
